function formatePage(ret) {
    const {
        pageNumber = 1,
        pageSize = 0,
        total = 0,
        rows = [],
        pageTotal = 0
    } = ret
    return {
        pageNum: pageNumber,
        pageSize: pageSize,
        total: total,
        totalPages: pageTotal,
        list: rows
    }
}

/***
 * 格式化百分比的方法
 * @param value 当前值
 * @param sum   总值
 * @param point 小数点
 * @param detailPoint 更详细的小数点
 * @return {string} 百分比的字符串
 */
export const formatPercent = function (value = 0, sum = 0, point = 0, detailPoint = 2) {
    const number = (value * 100 / sum) || 0
    const ret = number.toFixed(number != 0 && number < 1 ? detailPoint : point)
    return ret + '%'
}

export const formatData = function (params) {

    params && Object.keys(params).forEach(key => {
        if (params[key] == null || params[key] == undefined||params[key] == 'null' || params[key] == 'undefined') delete params[key]
    })
}
export function formatTreeDisUnit(tree ) {
    recursionTree(tree,(item=>{
        item.disabled = 'Unit' === item.type;
        item.value=item.id
        item.title=item.name
    }))
}
function recursionTree(tree,eachItemFunc) {
    tree && tree.length && tree.forEach(item => {
        eachItemFunc&&eachItemFunc(item)
        recursionTree(item.children, eachItemFunc)
    })
    
}